'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PHONE_NUMBER_LENGTH = 11;
// import messages from '../lang/default-messages';

// import { FormattedMessage } from 'react-intl';

var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var validPhone = function validPhone(number) {
	return typeof number === 'string' && number.length && number.match(/\d/g).length === PHONE_NUMBER_LENGTH;
};
var validateBirthday = function validateBirthday(birthday) {
	return !(birthday.substring(0, 2) === '00') && !(birthday.substring(3, 6) === 'xxx') && !(birthday.substring(7, 11) === '0000') ? true : false; //eslint-disable-line
};

var now = (0, _moment2.default)();
var days = [];
var months = [];
var years = [];

var YEARS_TO_DISPLAY = 100;
var DAYS_TO_DISPLAY = 31;
var MINIMUM_AGE = 16;

for (var i = 1; i <= DAYS_TO_DISPLAY; i++) {
	days.push(_react2.default.createElement(
		'option',
		{ key: 'day' + i, value: i },
		i
	));
}

var MONTH_VALUES = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
for (var _i = 0; _i < MONTH_VALUES.length; _i++) {
	months.push(_react2.default.createElement(
		'option',
		{ key: 'month' + _i, value: MONTH_VALUES[_i] },
		_moment2.default.months(_i)
	));
}

for (var _i2 = (0, _moment2.default)().subtract(MINIMUM_AGE, 'years').get('year'); _i2 >= (0, _moment2.default)().get('year') - YEARS_TO_DISPLAY; _i2--) {
	years.push(_react2.default.createElement(
		'option',
		{ key: 'year' + _i2, value: _i2 },
		_i2
	));
}

var validateAndSubmit = function validateAndSubmit(props, mustValidatePromoCode) {
	if (mustValidatePromoCode) {
		props.onValidatePromoCode();
	} else {
		props.onSubmit(props.requestData).then(function () {
			(0, _doctifyUtils.fireGTMevent)('lead_submit_' + props.packageType);
		});
	}
};

var BookHealthCheck = function BookHealthCheck(props) {
	var mustValidatePromoCode = props.promoCode && (!props.promoCodeEntered || !props.validPromoCode);
	return _react2.default.createElement(
		'form',
		{ className: 'form-horizontal ' + _style2.default.bookHealthCheck + ' ' + props.className + ' ' + (props.submitFailed ? _style2.default.submitError : '') },
		props.account && props.account.specialist && _react2.default.createElement(
			'div',
			{ className: _style2.default.specialistError },
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						null,
						'You appear to be logged in as a Specialist. Accounts of this type cannot request appointments. Please log into a patient account to proceed.'
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.actionContainer },
				_react2.default.createElement(
					'div',
					{ className: 'form-group ' + _style2.default.action },
					_react2.default.createElement(
						'button',
						{ className: 'btn specialist',
							type: 'button',
							onClick: function onClick() {
								return props.closeModal();
							} },
						'Cancel'
					)
				)
			)
		),
		!props.account || !props.account.specialist && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'form-group ' + _style2.default.nameInput },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement('i', { className: 'ion-ios-contact' }),
						_react2.default.createElement('input', { className: 'form-control',
							defaultValue: props.requestData && props.requestData.firstname || '',
							placeholder: 'First name *',
							onChange: function onChange(event) {
								return props.onFirstNameChange(event.target.value);
							},
							required: true })
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group ' + _style2.default.nameInput + ' ' + _style2.default.lastName },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement('i', { className: 'ion-ios-contact' }),
						_react2.default.createElement('input', { className: 'form-control',
							defaultValue: props.requestData && props.requestData.lastname || '',
							placeholder: 'Last name *',
							onChange: function onChange(event) {
								return props.onLastNameChange(event.target.value);
							},
							required: true })
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
						_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !emailRegex.test(props.requestData.email) ? _style2.default.validationError : ''),
							defaultValue: props.requestData && props.requestData.email || '',
							placeholder: 'Email *',
							onChange: function onChange(event) {
								return props.onEmailChange(event.target.value);
							},
							required: true })
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement('i', { className: 'ion-ios-telephone' }),
						_react2.default.createElement('input', { className: 'form-control ' + (props.submitFailed && !validPhone(props.requestData.phone) ? _style2.default.validationError : ''),
							placeholder: 'Phone *',
							onChange: function onChange(event) {
								return props.onPhoneChange(event.target.value);
							},
							required: true })
					)
				)
			),
			!(props.account && props.account.patient && props.account.patient.email) && _react2.default.createElement(
				'div',
				{ className: 'form-group ' + _style2.default.hidden },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement(
							'select',
							{ className: 'form-control ' + _style2.default.noIcon,
								defaultValue: props.requestData && props.requestData.attributes && props.requestData.attributes.gender || '',
								onChange: function onChange(event) {
									props.onGenderChange(event.target.value);
								},
								required: true },
							_react2.default.createElement(
								'option',
								{ disabled: true, value: '' },
								'Gender *'
							),
							_react2.default.createElement(
								'option',
								{ value: 'm' },
								'Male'
							),
							_react2.default.createElement(
								'option',
								{ value: 'f' },
								'Female'
							)
						),
						_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
					)
				)
			),
			!(props.account && props.account.patient && props.account.patient.email) && _react2.default.createElement(
				'div',
				{ className: _style2.default.dateContainer },
				_react2.default.createElement(
					'label',
					null,
					'Date of Birth *'
				),
				_react2.default.createElement(
					'div',
					{ className: 'form-group ' + _style2.default.formGroup },
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-4 ' + _style2.default.dateInput + ' ' + _style2.default.dayInput },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_react2.default.createElement(
								'select',
								{ className: 'form-control ' + _style2.default.noIcon,
									defaultValue: props.requestData && props.requestData.attributes && props.requestData.attributes.birthdate && props.requestData.attributes.birthdate.substring(0, 2) !== '00' && props.requestData.attributes.birthdate.substring(0, 2) || '',
									onChange: function onChange(event) {
										props.onBirthdateDayChange(event.target.value);
									},
									required: true },
								_react2.default.createElement(
									'option',
									{ disabled: true, value: '' },
									'Day *'
								),
								days.map(function (day) {
									return day;
								})
							),
							_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-4 ' + _style2.default.dateInput + ' ' + _style2.default.monthInput },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_react2.default.createElement(
								'select',
								{ className: 'form-control ' + _style2.default.noIcon,
									defaultValue: props.requestData && props.requestData.attributes && props.requestData.attributes.birthdate && props.requestData.attributes.birthdate.substring(3, 6) !== 'xxx' && props.requestData.attributes.birthdate.substring(3, 6) || '',
									onChange: function onChange(event) {
										props.onBirthdateMonthChange(event.target.value);
									},
									required: true },
								_react2.default.createElement(
									'option',
									{ disabled: true, value: '' },
									'Month *'
								),
								months.map(function (month) {
									return month;
								})
							),
							_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-xs-4 ' + _style2.default.dateInput + ' ' + _style2.default.yearInput },
						_react2.default.createElement(
							'div',
							{ className: 'df-input-group' },
							_react2.default.createElement(
								'select',
								{ className: 'form-control ' + _style2.default.noIcon,
									defaultValue: props.requestData && props.requestData.attributes && props.requestData.attributes.birthdate && props.requestData.attributes.birthdate.substring(7, 11) !== '0000' && props.requestData.attributes.birthdate.substring(7, 11) || '',
									onChange: function onChange(event) {
										props.onBirthdateYearChange(event.target.value);
									},
									required: true },
								_react2.default.createElement(
									'option',
									{ disabled: true, value: '' },
									'Year *'
								),
								years.map(function (year) {
									return year;
								})
							),
							_react2.default.createElement('i', { className: 'ion-ios-arrow-down' })
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group' },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-12' },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group textarea' },
						_react2.default.createElement('textarea', { className: 'form-control', placeholder: 'Reason for visit', onChange: function onChange(event) {
								return props.onReasonForVisitChange(event.target.value);
							} })
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'form-group ' + _style2.default.promoCodeContainer },
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-6 ' + _style2.default.inputContainer },
					_react2.default.createElement(
						'div',
						{ className: 'df-input-group' },
						_react2.default.createElement('i', { className: 'ion-ios-pricetag-outline' }),
						_react2.default.createElement('input', { className: 'form-control',
							placeholder: 'Promo code',
							onChange: function onChange(event) {
								return props.onPromoCodeChange(event.target.value);
							},
							onKeyDown: function onKeyDown(event) {
								return event.keyCode === 13 ? props.onValidatePromoCode() : function () {};
							}
						})
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'col-sm-6 ' + _style2.default.buttonContainer },
					_react2.default.createElement(
						'button',
						{ className: 'btn solid practice', id: _style2.default.validate, type: 'button', onClick: function onClick() {
								return props.onValidatePromoCode();
							} },
						'Apply'
					)
				)
			),
			props.requestData && props.requestData.promotion_code && props.requestData.promotion_code.entitlement && props.promoCodeEntered && props.validPromoCode && _react2.default.createElement(
				'div',
				{ className: _style2.default.validPromoCode },
				_react2.default.createElement(
					'p',
					null,
					props.requestData.promotion_code.entitlement
				)
			),
			props.promoCodeEntered && !props.validPromoCode && _react2.default.createElement(
				'div',
				{ className: _style2.default.invalidPromoCode },
				_react2.default.createElement(
					'p',
					null,
					'Invalid promo code'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.footnotes },
				_react2.default.createElement(
					'p',
					null,
					'* indicates required field'
				)
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.actionsContainer },
				_react2.default.createElement(
					'div',
					{ className: 'form-group ' + _style2.default.action },
					_react2.default.createElement(
						'div',
						{ className: 'col-sm-12' },
						_react2.default.createElement(
							'button',
							{ className: 'btn solid ' + _style2.default.submitButton + ' ' + (mustValidatePromoCode ? _style2.default.invalidCodeButton : ''),
								type: 'button',
								onClick: function onClick() {
									if (mustValidatePromoCode) {
										return;
									}
									if (props.requestData.firstname && props.requestData.firstname.length && props.requestData.lastname && props.requestData.lastname.length && props.requestData.email && emailRegex.test(props.requestData.email) && props.requestData.lastname && validPhone(props.requestData.phone)) {
										if (!props.patient.email) {
											if (props.requestData.attributes.birthdate && validateBirthday(props.requestData.attributes.birthdate)) {
												validateAndSubmit(props, mustValidatePromoCode);
												return;
											} else {
												props.validationError();
												return;
											}
										} else {
											validateAndSubmit(props, mustValidatePromoCode);
											return;
										}
									} else {
										props.validationError();
									}
								},
								'data-tip': 'Please apply a valid promo code or clear the box to continue.',
								'data-tip-disable': !mustValidatePromoCode },
							'Submit'
						),
						_react2.default.createElement(
							'button',
							{ className: 'btn specialist',
								type: 'button',
								onClick: function onClick() {
									return props.closeModal();
								} },
							'Cancel'
						),
						_react2.default.createElement(_reactTooltip2.default, { className: _style2.default.submitButtonTooltip, place: 'top' })
					)
				)
			)
		)
	);
};

BookHealthCheck.propTypes = {
	account: require('react').PropTypes.object.isRequired,
	requestData: require('react').PropTypes.object.isRequired,
	promoCode: require('react').PropTypes.any.isRequired,
	promoCodeEntered: require('react').PropTypes.any.isRequired,
	validPromoCode: require('react').PropTypes.any.isRequired,
	promoCodeMessage: require('react').PropTypes.any.isRequired,
	onFirstNameChange: require('react').PropTypes.func.isRequired,
	onLastNameChange: require('react').PropTypes.func.isRequired,
	onEmailChange: require('react').PropTypes.func.isRequired,
	onPhoneChange: require('react').PropTypes.func.isRequired,
	onGenderChange: require('react').PropTypes.func.isRequired,
	onBirthdateDayChange: require('react').PropTypes.func.isRequired,
	onBirthdateMonthChange: require('react').PropTypes.func.isRequired,
	onBirthdateYearChange: require('react').PropTypes.func.isRequired,
	onReasonForVisitChange: require('react').PropTypes.func.isRequired,
	onPromoCodeChange: require('react').PropTypes.func.isRequired,
	onValidatePromoCode: require('react').PropTypes.func.isRequired,
	onSubmit: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	validationError: require('react').PropTypes.func.isRequired,
	submitFailed: require('react').PropTypes.any.isRequired,
	className: require('react').PropTypes.any.isRequired
};
BookHealthCheck.displayName = 'BookHealthCheck';

BookHealthCheck.defaultProps = {};

exports.default = BookHealthCheck;


// WEBPACK FOOTER //
// ./components/book-health-check/lib/components/book-health-check.js